import { AssetProductCategory } from './asset-product-category-entity';
import { BaseEntity } from 'src/app/tools/models/baseEntity';

export class AssetProduct extends BaseEntity {
  
    id                      : number;
    assetProductCode		    : string; 
    name 		                : string;  
    longDescription	  	    : string;  
    rank 		                : number;
    assetProductCategory    : AssetProductCategory = new AssetProductCategory();
   

    // Transient
    quantity  : number;
    amount    : number;
 
    constructor() {
      super();
    }
}
